module.exports = __webpack_public_path__ + "static/media/ic_document_cloud.3c4d966e.svg";